/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { omit } from './lodash';
import hoistInstance from './hoist-non-react-instance-functions';

export default function(defaultDelay = 250) {
	return function(WrappedComponent) {
		class DelayMount extends Component {
			static propTypes = {
				delay: PropTypes.number,
			};

			static defaultProps = {
				delay: defaultDelay,
			};

			state = {
				mount: this.props.delay <= 0,
			};

			componentDidMount() {
				if (!this.state.mount) {
					this._handle = setTimeout(() => {
						delete this._handle;
						this.setState({ mount: true });
					}, this.props.delay);
				}
			}

			componentWillUnmount() {
				this._handle && clearTimeout(this._handle);
			}

			_ref = wc => {
				wc && hoistInstance(this, wc);
			};

			render() {
				const { mount } = this.state;
				if (!mount) {
					return null;
				}
				const props = omit(this.props, 'delay');

				return <WrappedComponent {...props} ref={this._ref} />;
			}
		}

		DelayMount.WrappedComponent = WrappedComponent;

		return DelayMount;
	};
}
